import {Component, OnInit} from '@angular/core';
import {CssService} from "../../../../services/css-service";

@Component({
  selector: 'app-powered-fulle',
  templateUrl: './powered-fulle.component.html',
  styleUrls: ['./powered-fulle.component.css']
})
export class PoweredFulleComponent implements OnInit {
  FULLE_URL = "https://fulleapps.com/"

  constructor(public cssService : CssService) {
    // constructor
  }

  ngOnInit() {
    // ngOnInit
  }

  /**
   * @description Redirige vers le site de fulle
   */
  goFulle(): void {
    window.open(this.FULLE_URL);
  }
}
